export default __webpack_public_path__ + "static/media/Qworky_Banner.ef412879.jpg";